import { EllipsisOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Button, Dropdown } from 'antd'
import { useRef } from 'react'

import type { CatalogImage, ImageAction } from '../api'

export function ImageActions({
  image,
  edit,
  act,
}: {
  image: CatalogImage
  edit: (image: CatalogImage) => void
  act: (image: CatalogImage, action: ImageAction) => void
}) {
  const trigger = useRef<HTMLButtonElement>(null)
  const status = image.state.status
  const items: MenuProps['items'] = [
    { key: 'edit', label: 'Edit details', onClick: () => edit(image) },
  ]
  if (status === 'HIDDEN') {
    items.push({
      key: 'publish',
      label: 'Publish',
      onClick: () => act(image, 'publish'),
    })
  }
  if (status === 'PUBLISHED') {
    items.push(
      {
        key: 'default',
        label: 'Set default',
        onClick: () => act(image, 'default'),
      },
      { key: 'hide', label: 'Hide', onClick: () => act(image, 'hide') },
    )
  }
  items.push({ type: 'divider' })
  if (status === 'DEFAULT') {
    items.push({
      key: 'protected',
      label: 'Change default before hiding or removing',
      disabled: true,
    })
  } else {
    items.push({
      key: 'remove',
      label: 'Remove',
      danger: true,
      onClick: () => act(image, 'remove'),
    })
  }
  return (
    <Dropdown
      menu={{
        items,
        onKeyDown: (event) => {
          if (event.key === 'Escape') trigger.current?.focus()
        },
      }}
      trigger={['click']}
      placement="bottomRight"
      autoFocus
    >
      <Button
        ref={trigger}
        aria-label={`Actions for ${image.distribution} ${image.name}`}
        icon={<EllipsisOutlined />}
      />
    </Dropdown>
  )
}
